import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import { ApiVisa } from 'blg-akaun-ts-lib';
import { SessionActions } from '../../modules/session/session-controller/actions';
import { SessionSelectors } from '../../modules/session/session-controller/selectors';
import { SessionStates } from '../../modules/session/session-controller/states';
import { DropDownService } from '../../services/drop-down-service';
import { ReplaySubject, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { ListingInputModel } from '../../models/listing-input.model';
import { ListingService } from '../../services/listing-service';
import { SharedUtilitiesHelperFunctions } from '../helper-functions';

@Component({
  selector: 'app-select-multi-fi-item-drop-down',
  templateUrl: './select-multi-fi-item-drop-down.component.html',
  styleUrls: ['./select-multi-fi-item-drop-down.component.css']
})
export class SelectMultiFiItemDropDownComponent implements OnInit, OnDestroy {

  @Input() fiItem: FormControl;
  @Input() apiVisa: ApiVisa;
  @Input() defaultRows: any = [];
  @Input() label = 'FI Item';
  @Input() options: any;

  @Output() fiItemSelected = new EventEmitter<any>();

  serverSideFiltering = new FormControl();
  filteredOptions$: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  selectedRow: any;
  rowData: any = [];
  key = "fiItem";
  allSelected = false;
  filteredCache: any = [];

  /** flags to set the toggle all checkbox state */
  isIndeterminate = false;
  isChecked = false;
  
  protected _onDestroy = new Subject<void>();

  constructor(private dropDownService: DropDownService,
    private listingService: ListingService, 
    private readonly store: Store<SessionStates>
  ) { }

  ngOnInit() {
    // set initial selection
    if (this.defaultRows.length > 0) {
      this.rowData = [...this.rowData, ...this.defaultRows];
      this.filteredOptions$.next(this.defaultRows.slice());
    }
    else {
      this.store.select(SessionSelectors.selectDropDownRowData).subscribe(resolved => {
        this.rowData = resolved?resolved[this.key]?resolved[this.key]:[]:[];
        if (this.rowData.length === 0) {
          this.getRowData();
        }
        else {
          this.filteredOptions$.next(this.rowData.slice());
        }
      })
    }

    // listen for search field value changes
    this.serverSideFiltering.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filtering();
      });
  }

  ngOnChanges() {
    console.log('ngOnChanges');
  }

  getRowData(keyword?) {
    let formData = this.getInputModel(keyword);
    this.listingService.get("fi-item", formData, this.apiVisa).pipe(
      
    ).subscribe(resolved => {
      // this.rowData = resolved.data;
      this.rowData = [...this.rowData, ...resolved.data];
      this.rowData = SharedUtilitiesHelperFunctions.removeDuplicate(this.rowData, 'guid');
      
      // sorting
      const sorted = this.rowData.sort((a, b) => (a.code < b.code ? -1 : 1));

      this.store.dispatch(SessionActions.selectDropDownRowData({key: this.key, rowData: this.rowData}));
      
      //fill the drop down
      if (keyword) {
        this.filteredOptions$.next(resolved.data.slice());
      }
      else {
        this.filteredOptions$.next(this.rowData.slice());
      }
    });
  }

  filtering() {
    if (!this.rowData) {
      return;
    }

    // get the search keyword
    let search = this.serverSideFiltering.value;
    if (!search || search.length < 3) {
      this.filteredOptions$.next(this.rowData.slice());
      return;
    } else {
      search = search.toLowerCase();
      this.getRowData(search);
    }
  }

  onSelect(guid: string) {
    if (guid) {
      this.fiItem.patchValue(guid);
      this.selectedRow = this.rowData.find(row => row.guid === guid);
      this.fiItemSelected.emit(this.selectedRow);
    }
  }

  isRequired() {
    let value = this.options['required'];
    if (value === true || value === false) {
      return value;
    }
    else if (value) {
      return value.includes(true);
    }
    return false; 
  }

  isMultiple() {
    let value = this.options['multiple'];
    if (value === true || value === false) {
      return value;
    }
    else if (value) {
      return value.includes(true);
    }
    return false; 
  }

  toggleSelectAll(selectAllValue: boolean) {
    this.filteredOptions$.pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(val => {
        if (selectAllValue) {
          this.fiItem.patchValue([...val.map(item => item.guid)]);
        } else {
          this.fiItem.patchValue([]);
        }
      });
  }

  setToggleAllCheckboxState() {
    if (!this.isMultiple()) return;
    let filteredLength = 0;
    if (this.fiItem && this.fiItem.value) {
      this.filteredCache.forEach(el => {
        if (this.fiItem.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminate = filteredLength > 0 && filteredLength < this.filteredCache.length;
      this.isChecked = filteredLength > 0 && filteredLength === this.filteredCache.length;
    }
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  getInputModel(keyword?) {
    const inputModel = {} as ListingInputModel;
    inputModel.search =  ( keyword ? keyword : '');
    inputModel.searchColumns = ['code', 'name'];
    inputModel.status = ['ACTIVE'];
    inputModel.orderBy = 'code';
    inputModel.order = 'asc';
    inputModel.limit = 50;
    inputModel.offset = 0;
    inputModel.calcTotalRecords = false;
    inputModel.showCreatedBy = false;
    inputModel.showUpdatedBy = false;
    inputModel.filterLogical= 'AND';

    return inputModel;
  }

  displayRow(code, name) {
    return code + (name? ' | ' + name : ''); 
  }
}
